const createOption = (name, value = undefined) => {
	const option = document.createElement("OPTION");
	option.setAttribute('value', value === undefined ? name : value);
	option.innerHTML = name;

	return option;
};

export default createOption;



// WEBPACK FOOTER //
// ./src/js/index/createOption.js